import { ERROR, LOADING, SUCCESS, SUCCESS_STATS, CLEAR } from './CFDActions';

const INITIAL_STATE = {
  isLoading: true,
  success: false,
  error: '',
  data: [],
  stats: undefined,
  arrivalDepTrends: undefined,
};

const CFDReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ERROR: {
      return { ...state, error: action.error };
    }
    case LOADING: {
      return { ...state, isLoading: action.isLoading };
    }
    case SUCCESS: {
      return { ...state, isLoading: false, data: action.data };
    }
    case CLEAR: {
      return { ...state, ...action };
    }
    case SUCCESS_STATS: {
      return {
        ...state,
        stats: action.stats,
        arrivalDepTrends: action.arrivalDepTrends,
      };
    }
    default:
      return state;
  }
};

export default CFDReducer;
